import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { useState } from "react";
import api from "../lib/api";
import { toast } from "sonner";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const subscribe = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message);
      setEmail("");
    } catch {
      toast.error("Please enter a valid email.");
    }
  };

  return (
    <footer className="bg-[#0F0F0F] text-white mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="inline-flex items-center bg-white rounded-2xl px-4 py-3 mb-4">
              <img src="/meow-care-logo-v2.png" alt="Meow Care Love" className="h-12 w-auto object-contain" />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Meow Care Love curates the best products on the internet for owners managing difficult, recurring problems — built for senior cats and cats with chronic conditions. Only the best for our loves.
            </p>
          </div>

          <div>
            <h4 className="font-display font-bold mb-4">Collections</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/shop?collection=medication" className="hover:text-[#FF5C28]">Medication Made Easier</Link></li>
              <li><Link to="/shop?collection=hydration" className="hover:text-[#FF5C28]">Hydration & Urinary</Link></li>
              <li><Link to="/shop?collection=mobility" className="hover:text-[#FF5C28]">Senior Mobility</Link></li>
              <li><Link to="/shop?collection=appetite" className="hover:text-[#FF5C28]">Appetite & Weight</Link></li>
              <li><Link to="/shop?collection=litter" className="hover:text-[#FF5C28]">Litter-Box Recovery</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/about" className="hover:text-[#FF5C28]">About Us</Link></li>
              <li><Link to="/shop?collection=bundles" className="hover:text-[#FF5C28]">Bundles & Kits</Link></li>
              <li><Link to="/shop?collection=guides" className="hover:text-[#FF5C28]">Care Guides</Link></li>
              <li><Link to="/account" className="hover:text-[#FF5C28]">My Account</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold mb-4">Free Senior Cat Safety Check</h4>
            <p className="text-gray-400 text-sm mb-3">Join our list for the free checklist & care tips.</p>
            <form onSubmit={subscribe} className="flex gap-2">
              <input data-testid="footer-newsletter-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                className="flex-1 bg-white/10 border border-white/20 rounded-full px-4 py-2.5 text-sm focus:outline-none focus:border-[#FF5C28]" />
              <button data-testid="footer-newsletter-submit" className="bg-[#FF5C28] hover:bg-[#E04D1E] rounded-full px-4 py-2.5 transition-colors">
                <Mail className="w-4 h-4" />
              </button>
            </form>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:row items-center justify-between gap-4 text-sm text-gray-500">
          <p>© 2026 Meow Care Love. We organize care — we never replace your vet.</p>
          <div className="flex gap-2 items-center">
            <span className="bg-white/10 rounded-full px-3 py-1 text-xs font-semibold">Veterinary Reviewed</span>
            <span className="bg-white/10 rounded-full px-3 py-1 text-xs font-semibold">Free Shipping $50+</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
